<ng-container [ngSwitch]="ballot.type">
  <ng-container *ngSwitchCase="'exchange'">
    <ng-container *ngTemplateOutlet="exchange"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'formation'">
    <ng-container *ngTemplateOutlet="formation"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'purchase'">
    <ng-container *ngTemplateOutlet="purchase"></ng-container>
  </ng-container>
</ng-container>


<!-- Exchange Template -->
<ng-template #exchange>
  <ion-card color="primary" id="ballot-{{ballot.id}}" [hidden]="hidden" [ngClass]="{'ballot-card': true, 'revealed': !!showVotesOf, 'animate__animated animate__bounceOutRight': animateBeforeDelete, 'boosted': !!ballot.boosted }">

    <!-- <ion-button (click)="delete()" color="danger" class="delete-round-button ion-no-padding ion-no-margin">
      <ion-icon name="close-outline" slot="icon-only"></ion-icon>
    </ion-button> -->
    <ion-button (click)="returnToBallotsPair(ballot.id)" class="gradient__primary-secondary-135" i18n>
      <ion-icon slot="icon-only" name="arrow-undo"></ion-icon>
    </ion-button>

    <ion-grid>
      <ion-row>
        <ion-col size="12" class="ion-align-items-center ion-align-self-center ion-text-center">
          <ion-card-header class="ion-no-padding">
            <ion-card-title>
              <ion-text i18n>Proposta di scambio</ion-text>
            </ion-card-title>
            <ion-card-subtitle>{{ ballot.matrixArray[0] }} X {{ ballot.matrixArray[0] }}</ion-card-subtitle>
          </ion-card-header>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6" class="ion-align-items-center ion-align-self-center ion-text-center ion-no-padding">
          <div *ngFor="let p of ballot.left_players">
            <span class="surname-box">{{p.surname}}</span>
          </div>
          <div *ngIf="!!showVotesOf" class="exchange-percentage-container">
            <div class="percentage-number">{{ ballot.left_percentage }}%</div>
            <div class="percentage-bar"><ion-progress-bar value="{{ ballot.left_percentage / 100 }}"></ion-progress-bar></div>
          </div>
        </ion-col>
        <ion-col size="6" class="ion-align-items-center ion-align-self-center ion-text-center ion-no-padding">
          <div *ngFor="let p of ballot.right_players">
            <span class="surname-box">{{p.surname}}</span>
          </div>
          <div *ngIf="!!showVotesOf" class="exchange-percentage-container">
            <div class="percentage-number">{{ ballot.right_percentage }}%</div>
            <div class="percentage-bar"><ion-progress-bar value="{{ ballot.right_percentage / 100 }}"></ion-progress-bar></div>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" class="ion-align-items-center ion-align-self-center ion-text-center">
          <b *ngIf="!!showVotesOf">{{ ballot.total_votes }} <ion-text i18n>Voti</ion-text></b>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" class="ion-align-items-center ion-align-self-center ion-text-center">
          <ion-button (click)="update()" class="gradient__primary-secondary-135 btn-aggiorna" i18n>Aggiorna</ion-button>
          <app-boost [ballot]="ballot" [loggedUser]="loggedUser" [freeBoost]="loggedUser.boosts"></app-boost>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
</ng-template>



<!-- Formation Template -->
<ng-template #formation>
  <ion-card color="primary" id="ballot-{{ballot.id}}" [hidden]="hidden" [ngClass]="{'ballot-card': true, 'revealed': !!showVotesOf, 'animate__animated animate__bounceOutRight': animateBeforeDelete, 'boosted': !!ballot.boosted }">

    <!-- <ion-button (click)="delete()" color="danger" class="delete-round-button ion-no-padding ion-no-margin">
      <ion-icon name="close-outline" slot="icon-only"></ion-icon>
    </ion-button> -->
    <ion-button (click)="returnToBallotsPair(ballot.id)" class="gradient__primary-secondary-135" i18n>
      <ion-icon slot="icon-only" name="arrow-undo"></ion-icon>
    </ion-button>

    <ion-grid>
      <ion-row>
        <ion-col size="12" class="ion-align-items-center ion-align-self-center ion-text-center">
          <ion-card-header class="ion-no-padding">
            <ion-card-title>
              <ion-text i18n>Dubbio di formazione</ion-text>
            </ion-card-title>
            <ion-card-subtitle>{{ ballot.matrixArray[0] }} <ion-text i18n>SU</ion-text> {{ ballot.matrixArray[1] }}</ion-card-subtitle>
          </ion-card-header>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" class="ion-align-items-center ion-align-self-center ion-text-center">
          <div *ngFor="let p of ballot.players">
            <ion-grid class="ion-no-padding">
              <ion-row>
                <ion-col size="5" class="ion-align-items-center ion-align-self-left ion-text-left ion-no-padding ion-padding-start">
                  <span class="surname-box">{{ p.surname }}</span>
                </ion-col>
                <ion-col size="4" class="ion-align-items-center ion-align-self-center ion-no-padding">
                    <div *ngIf="!!showVotesOf" class="percentage-bar">
                      <ion-progress-bar value="{{ ballot.votes[p.id].percentage / 100 }}"></ion-progress-bar>
                    </div>
                </ion-col>
                <ion-col size="3" class="ion-align-items-center ion-align-self-center ion-text-left ion-no-padding ion-padding-start">
                  <div *ngIf="!!showVotesOf" class="percentage-number">{{ ballot.votes[p.id].percentage }}%</div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" class="ion-align-items-center ion-align-self-center ion-text-center">
          <b *ngIf="!!showVotesOf">{{ ballot.total_votes }} <ion-text i18n>Voti</ion-text></b>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" class="ion-align-items-center ion-align-self-center ion-text-center">
          <ion-button (click)="update()" class="gradient__primary-secondary-135 btn-aggiorna" i18n>Aggiorna</ion-button>
          <app-boost [ballot]="ballot" [loggedUser]="loggedUser" [freeBoost]="loggedUser.boosts"></app-boost>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
</ng-template>



<!-- Purchase Template -->
<ng-template #purchase>
  <ion-card color="primary" id="ballot-{{ballot.id}}" [hidden]="hidden" [ngClass]="{'ballot-card': true, 'revealed': !!showVotesOf, 'animate__animated animate__bounceOutRight': animateBeforeDelete, 'boosted': !!ballot.boosted }">

    <!-- <ion-button (click)="delete()" color="danger" class="delete-round-button ion-no-padding ion-no-margin">
      <ion-icon name="close-outline" slot="icon-only"></ion-icon>
    </ion-button> -->
    <ion-button (click)="returnToBallotsPair(ballot.id)" class="gradient__primary-secondary-135" i18n>
      <ion-icon slot="icon-only" name="arrow-undo"></ion-icon>
    </ion-button>

    <ion-grid>
      <ion-row>
        <ion-col size="12" class="ion-align-items-center ion-align-self-center ion-text-center">
          <ion-card-header class="ion-no-padding">
            <ion-card-title>
              <ion-text i18n>Dubbio di acquisto</ion-text>
            </ion-card-title>
            <ion-card-subtitle>{{ ballot.matrixArray[0] }} <ion-text i18n>SU</ion-text> {{ ballot.matrixArray[1] }}</ion-card-subtitle>
          </ion-card-header>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" class="ion-align-items-center ion-align-self-center ion-text-center">
          <div *ngFor="let p of ballot.players">
            <ion-grid class="ion-no-padding">
              <ion-row>
                <ion-col size="5" class="ion-align-items-center ion-align-self-center ion-text-left ion-no-padding ion-padding-start">
                  <span class="surname-box">{{ p.surname }}</span>
                </ion-col>
                <ion-col size="4" class="ion-align-items-center ion-align-self-center ion-no-padding">
                    <div *ngIf="!!showVotesOf" class="percentage-bar">
                      <ion-progress-bar value="{{ ballot.votes[p.id].percentage / 100 }}"></ion-progress-bar>
                    </div>
                </ion-col>
                <ion-col size="3" class="ion-align-items-center ion-align-self-center ion-text-left ion-no-padding ion-padding-start">
                  <div *ngIf="!!showVotesOf" class="percentage-number">{{ ballot.votes[p.id].percentage }}%</div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" class="ion-align-items-center ion-align-self-center ion-text-center">
          <b *ngIf="!!showVotesOf">{{ ballot.total_votes }} <ion-text i18n>Voti</ion-text></b>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" class="ion-align-items-center ion-align-self-center ion-text-center">
          <ion-button (click)="update()" class="gradient__primary-secondary-135 btn-aggiorna" i18n>Aggiorna</ion-button>
          <app-boost [ballot]="ballot" [loggedUser]="loggedUser" [freeBoost]="loggedUser.boosts"></app-boost>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
</ng-template>